import { ResendInvitationMeta, ResendInvitationPayload } from 'types/store/ResendInvitation';
import { createAsyncReducer } from 'utils/Redux';

import { resendInvitationActions } from '../actions';

export default createAsyncReducer<ResendInvitationMeta, ResendInvitationPayload>(resendInvitationActions);
